import { updateRole } from '@infuse/api/iam/role';
import { useGenericUpdateRole } from './generic/useGenericUpdateRole';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { updateOrganisationRole } from '@infuse/api/iam/organisation';
import { updateTenantRole } from '@infuse/api/iam/tenant';

export const useUpdateRole = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericUpdateRole({
      apiFn: updateTenantRole,
      forcedParentId: user?.tenantId
    });
  } else if (level === UserLevel.ORGANISATION) {
    return useGenericUpdateRole({
      apiFn: updateOrganisationRole,
      forcedParentId: user?.organisationId
    });
  }

  return useGenericUpdateRole({
    apiFn: updateRole
  });
};
